<template>
    <v-select
        :items="itemsWithValue"
        :item-text="itemText"
        :item-value="itemValue"
        :value="internalValue"
        :label="label"
        @input="onInput"
        @change="onUserChange"
        :style="{ maxWidth: '120px' }"
    >
            {{ chipDisplayText }}
            <v-icon right small>mdi-chevron-down</v-icon>
    </v-select>
</template>

<script>
export default {
  name: "DueDaysDropdown",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    tooltip: {
      type: String,
      default: "",
    },
    daysTranslation: {
      type: String,
      default: "",
    },
    chipClass: {
      type: String,
      default: "",
    },
    itemText: {
      type: String,
      default: "text",
    },
    itemValue: {
      type: String,
      default: "id",
    },
  },
  emits: ["input", "change"],
  computed: {
    internalValue() {
      return this.value;
    },
    itemsWithValue() {
      if (this.internalValue == null || this.internalValue === "") {
        return this.items;
      }
      const exists = this.items.some(
        (i) => this.getItemValue(i) === this.internalValue
      );
      if (exists) {
        return this.items;
      }
      return [
        ...this.items,
        { [this.itemValue]: this.internalValue, [this.itemText]: `${this.internalValue} ${this.daysTranslation}` },
      ];
    },
    chipDisplayText() {
      if (this.daysTranslation) {
        return this.internalValue;
      }
      const item = this.items.find(
        (i) => this.getItemValue(i) === this.internalValue
      );
      return item ? this.getItemText(item) : this.internalValue;
    },
    tooltipText() {
      if (this.daysTranslation) {
        return `${this.internalValue} ${this.daysTranslation}`;
      }
      return this.tooltip;
    },
  },
  methods: {
    getItemText(item) {
      return item[this.itemText] ?? item;
    },
    getItemValue(item) {
      return item[this.itemValue] ?? item;
    },
    onInput(item) {
      const value = this.getItemValue(item);
      this.$emit("input", value);
    },
    onUserChange(value) {
      // Only fires on user interaction (blur after selection), not on programmatic updates
      this.$emit("change", value ?? this.internalValue);
    },
  },
};
</script>
